// UpdateKycStatus
import React, { useState } from 'react';
import axios from "axios";
// import { Check, X } from 'lucide-react';
// import "./FingpayEkyc.css"
import "./UpdateKycStatus.css";

export default function UpdateKycStatus() {
    const [userid, setUserid] = useState("");
    const [response, setResponse] = useState("")
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("success");
    const [modalMessage, setModalMessage] = useState("");


    const validateForm = () => {
        const newErrors = {};

        if (!userid.trim()) newErrors.userid = "User ID is required";
        if (!response || response === "") newErrors.response = "Please select Status";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setUserid("")
        setResponse("");
        setErrors({});
    };


    const handleSubmit = async () => {
        if (loading) return;
        if (!validateForm()) return;

        setLoading(true);

        try {
            const payload = {
                userid: userid.trim().toUpperCase(),
                response,

            };





            const apiresponse = await axios.post(
                "https://api.bumppypay.com/api/Apitranxt/kyc/updatekycstatus",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

           


            if (apiresponse.data?.status === "0") {
                setModalType("success");
                setModalMessage(apiresponse.data.msg);
                setShowModal(true);
                resetForm();
            } else {
                setModalType("error");
                setModalMessage(
                    apiresponse.data?.msg
                );
                setShowModal(true);
            }


        } catch (error) {
            const msg = error.response?.data?.title || error.response?.data?.errors?.service?.[0] || "Server error occurred";
            console.log(msg)
            setModalType("error");
            setModalMessage(msg);
            setShowModal(true);
           
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fa-wrapper">
            <div className="fa-text-center fa-mb-5">
                <h1 className="fa-title">FINGPAY AEPS E-KYC OnBoarding UPDATE</h1>
            </div>

            <div className="fa-card">
                <div className="fa-form-grid">


                    <div>
                        <label className="fa-label fa-mb-2">User Id</label>
                        <div className="fa-input-group">
                            <input
                                type="text"
                                className="fa-input"
                                placeholder="Enter User Id"
                                value={userid}
                                onChange={(e) => {
                                    setUserid(e.target.value);
                                    setErrors({ ...errors, userid: "" });
                                }}
                            />
                        </div>
                        {errors.userid && <div className="fa-error-text">{errors.userid}</div>}
                    </div>


                    <div>
                        <label className="fa-label fa-mb-2">Status</label>
                        <div className="fa-input-group">
                            <select
                                className="fa-input fa-select"
                                value={response}
                                onChange={(e) => {
                                    setResponse(e.target.value);
                                    setErrors({ ...errors, response: "" });
                                }}
                            >
                                <option value="" disabled>Choose status</option>
                                <option value="COMPLETE">Mark Complete (Bank Approved Directly)</option>
                                <option value="Y">Manually 1st Step E-Kyc Proceed</option>
                                <option value="N">Manually Reset E-Kyc</option>
                            </select>
                        </div>
                        {errors.response && <div className="fa-error-text">{errors.response}</div>}
                    </div>
                </div>

                <button className="fa-btn" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Processing Request..." : "Update KYC Status"}
                </button>
            </div>


            {showModal && (
                <div className="fa-modal-overlay">
                    <div className="fa-modal-content">
                        <div style={{
                            width: '70px', height: '70px', borderRadius: '50%',
                            backgroundColor: modalType === "success" ? '#ecfdf5' : '#fff1f2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}>
                            {/* {modalType === "success" ? (
                                <Check size={32} color="#10b981" strokeWidth={3} />
                            ) : (
                                <X size={32} color="#ef4444" strokeWidth={3} />
                            )} */}
                        </div>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>
                            {modalType === "success" ? "All Set!" : "Request Failed"}
                        </h3>
                        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '2rem' }}>
                            {modalMessage}
                        </p>
                        <button
                            className="fa-btn"
                            style={{ background: modalType === "success" ? '#10b981' : '#ef4444', marginTop: 0 }}
                            onClick={() => { setShowModal(false); }}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
